import { useState } from 'react';

export default function EarlyAccessSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    email: '',
    phone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.firstName || !formData.email || !formData.phone) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams({
        firstName: formData.firstName,
        email: formData.email,
        phone: formData.phone
      });

      const response = await fetch('https://readdy.ai/api/form/d6ke1s2gaju8afbceol0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ firstName: '', email: '', phone: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="early-access" className="bg-gradient-to-b from-black to-[#0A0A0A] py-40 lg:py-48">
      <div className="max-w-[800px] mx-auto px-6 lg:px-12 text-center">
        {/* Overline */}
        <p className="text-sm font-bold text-[#00FF88] uppercase tracking-[0.06em] mb-5">
          Early Access
        </p>

        {/* Headline */}
        <h2 className="text-5xl lg:text-7xl font-extrabold text-white mb-8 leading-tight">
          Be First. Founding Member Pricing.
        </h2>

        {/* Subheadline */}
        <p className="text-xl lg:text-2xl text-white/70 mb-14 max-w-[600px] mx-auto leading-relaxed">
          THRESH is in development. Early access members get founding pricing, first access to product samples, and direct input into what gets built. Drop your email.
        </p>

        {/* Form */}
        <form 
          onSubmit={handleSubmit} 
          className="mb-8"
          data-readdy-form
          id="early-access-signup-form"
        >
          <div className="flex flex-col lg:flex-row gap-4 mb-6">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              required
              className="flex-1 h-14 px-6 bg-white/10 text-white border border-white/30 rounded-lg placeholder:text-gray-400 focus:outline-none focus:border-[#00FF88] focus:ring-2 focus:ring-[#00FF88]/30 transition-all"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="flex-1 h-14 px-6 bg-white/10 text-white border border-white/30 rounded-lg placeholder:text-gray-400 focus:outline-none focus:border-[#00FF88] focus:ring-2 focus:ring-[#00FF88]/30 transition-all"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              required
              className="flex-1 h-14 px-6 bg-white/10 text-white border border-white/30 rounded-lg placeholder:text-gray-400 focus:outline-none focus:border-[#00FF88] focus:ring-2 focus:ring-[#00FF88]/30 transition-all"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="whitespace-nowrap h-14 px-10 lg:w-[240px] bg-[#00FF88] text-black font-bold rounded-lg hover:scale-105 hover:shadow-[0_0_40px_rgba(0,255,136,0.6)] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
            >
              {isSubmitting ? 'JOINING...' : 'GET EARLY ACCESS'}
            </button>
          </div>

          {submitStatus === 'success' && (
            <p className="text-[#00FF88] text-base font-semibold">You're in! Check your email for exclusive updates.</p>
          )}
          {submitStatus === 'error' && (
            <p className="text-red-400 text-base font-semibold">Something went wrong. Please try again.</p>
          )}
        </form>

        {/* Social Proof */}
        <div className="flex items-center justify-center gap-4">
          <div className="flex -space-x-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-400 to-gray-600 border-2 border-black"></div>
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-500 to-gray-700 border-2 border-black"></div>
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-400 to-gray-600 border-2 border-black"></div>
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-500 to-gray-700 border-2 border-black"></div>
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-400 to-gray-600 border-2 border-black"></div>
          </div>
          <p className="text-base text-white/60">
            Join 2,847 athletes
          </p>
        </div>
      </div>
    </section>
  );
}